import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/ops/")({
  beforeLoad: () => {
    throw redirect({ to: "/admin/ops/events", search: {} as never });
  },
});
